import { Component, computed, inject, input } from '@angular/core';
import { CopyOnHoverDirective } from '@myarvato/shared/copy';
import { ExceptionStatusChangeDto } from '@myarvato/modules/transport/models';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DayjsPipe } from '@myarvato/shared/pipelines';

@Component({
  selector: 'transport-exception-status-change',
  imports: [CopyOnHoverDirective, TranslatePipe, DayjsPipe],
  templateUrl: './exception-status-change.component.html',
  styleUrl: './exception-status-change.component.scss',
})
export class ExceptionStatusChangeComponent {
  private readonly translateService = inject(TranslateService);

  public readonly eventData = input.required<ExceptionStatusChangeDto>();

  protected readonly harmonizedEvent = computed(() => {
    return this.eventData().newResolutionStatusDescription ?? '';
  });

  protected readonly technicalInfo = computed(() => {
    const e = this.eventData();
    const parts: string[] = [];

    if (e.author && e.author.trim().length > 0) {
      parts.push(this.translateService.instant('pages.transport.detail-page.events.generated-by', { author: e.author }));
    }
    const infoBits: string[] = [];
    if (e.comment && e.comment.trim().length > 0) {
      infoBits.push(e.comment);
    }
    if (e.newSeverityDescription && e.newSeverityDescription.trim().length > 0) {
      infoBits.push(e.newSeverityDescription);
    }
    if (infoBits.length > 0) {
      parts.push(infoBits.join(' | '));
    }

    if (parts.length > 0) {
      return parts.join(', ');
    }
    return undefined;
  });
}
